// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"224":"1d04725a","982":"031260e8"}[chunkId] + ".chunk.css";
};